
import React from 'react';
import { Button } from '@/components/ui/button';
import { Calendar } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export const EmptyAppointments: React.FC = () => {
  const { t } = useTranslation('dashboard');

  return (
    <div className="bg-gray-50 rounded-lg p-8 text-center">
      <Calendar className="h-12 w-12 mx-auto mb-4 text-amber-600" />
      <h3 className="text-lg font-medium mb-2">{t('emptyAppointments.title')}</h3>
      <p className="text-gray-600 mb-6">{t('emptyAppointments.description')}</p>
      <Button asChild className="bg-amber-600 hover:bg-amber-700 text-white">
        <Link to="/booking-choice">{t('emptyAppointments.buttonText')}</Link>
      </Button>
    </div>
  );
};
